interface Tab {
	id: string
	label: string
}

/**
 * Filter tabs based on entity creation status and user role.
 *
 * - If no entity exists (creating), only show the first tab (General).
 * - viewerAdmin: show only 'general' and 'results'.
 * - admin: show all tabs except 'results'.
 * - both: show all tabs.
 * - undefined (loading/error): show only 'general' until role is confirmed.
 */
export function filterTabsByRole(tabs: Tab[], entityId: string | undefined, role: string | undefined): Tab[] {
	if (!entityId || entityId === 'create') {
		return [tabs[0]]
	}
	switch (role) {
		case 'viewerAdmin':
			return tabs.filter((t) => t.id === 'general' || t.id === 'results')
		case 'admin':
			return tabs.filter((t) => t.id !== 'results')
		case 'both':
			return tabs
		default:
			return [tabs[0]]
	}
}
